import React, { useCallback } from "react";
import { HeaderForm } from "@EUForms/header";
import { useDispatch, useSelector } from "react-redux";
import { updateShipmentFieldValue } from "../../reducer/headerSlice";
import {useEvent} from "@hooks/useEvent"
import { selectHeaderTabDS } from "@EUForms/selectors";
import EUStartJobButton from "../../../../header/ButtonMapper/euStartJobButton";
import { selectFilterTransmisisonTypeList } from "../../selectors";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";
import { getJobWheels } from "../../../../components/util";
//import { useValidation } from "@EUForms/hooks/useValidation";

const Header=({translate, kxUser, shipmentId, version, serviceType, fieldPattern,lowerEnv, searchByID})=> {
  const {saveForm}=useEvent("headerTab")
  const {currentJobData} =  useCurrentShipmentType()
 // const {validateError}=useValidation("headerTab")
  //const transmissionTypeList=useSelector(selectTransmissionTypeList)
  const jobWheels = getJobWheels(currentJobData);
  const entryState = jobWheels["ES_ENTRY_JOB_WHEEL"]?.value?.state || ""
 const customState =jobWheels["ES_CUSTOM_JOB_WHEEL"]?.value?.state||""
  const transmissionTypeList = useSelector((state) =>
    selectFilterTransmisisonTypeList(state, { entryState, customState })
  )
  const dispatch=useDispatch()
  const dataSource=useSelector(selectHeaderTabDS)

  const onSelect=useCallback((e, {value,name})=>{
    dispatch(updateShipmentFieldValue({[name]:value?.trim()}))
    saveForm({[name]:value})
    // validateError({[name]:value,procedure:"qd"},{[name]:fieldPattern()?.headerTab[name],
    //   procedure:fieldPattern()?.headerTab["procedure"]})
   },[updateShipmentFieldValue,saveForm])
   
   const renderActionBtns=useCallback(()=><EUStartJobButton 
                                            jobWheels={jobWheels} 
                                            kxUser={kxUser} 
                                            shipId={shipmentId} 
                                            declType={dataSource?.declType} 
                                            transmissionType={dataSource.transmissionType} 
                                            isCCDocEndRequest={dataSource.isCCDocEndRequest} 
                                            version={version} 
                                            serviceType={serviceType}
                                            translate={translate}
                                            lowerEnv={lowerEnv}
                                            searchByID={searchByID}
                                          />,[jobWheels, kxUser, shipmentId, dataSource.declType, dataSource.transmissionType,dataSource.isCCDocEndRequest, version, serviceType, currentJobData])
   //const renderActionBtns=useCallback(()=><Button>Start</Button>,[])

   return (
           <HeaderForm 
            transmissionList={transmissionTypeList}
            onSelect={onSelect}
            renderActionBtns={renderActionBtns}
            dataSource={dataSource}
            jobWheels={jobWheels}
           />
        );
}

export default React.memo(Header)
